import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({
    size,
    valueFormat = 'HH:mm:ss',
    clearable = false,
    disabled,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('el-time-picker')
    child.attrs = {
      ...child.attrs,
      size,
      'value-format': valueFormat,
      disabled,
      clearable
    }
    this.children = [child]
  }
}
